var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.077,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 511.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "0,0 0,47.995 253.24,217.59 512,47.979 512,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "512,512 512,463.867 256.052,296.332 0,464.09 0,512  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M371.928,291.588c3.467-11.278,5.351-23.251,5.351-35.665s-1.884-24.387-5.351-35.665L512,128.486  V47.979L334.934,163.987c-21.21-18.215-48.729-29.291-78.882-29.291c-30.152,0-57.672,11.075-78.882,29.291L0,47.62v80.833  l140.177,91.804c-3.467,11.278-5.351,23.251-5.351,35.665s1.884,24.387,5.351,35.665L0,383.411v80.678l177.171-116.231  c21.21,18.215,48.73,29.291,78.882,29.291s57.672-11.076,78.882-29.291L512,463.867v-80.508L371.928,291.588z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "247.325,217.158 229.06,217.632 238.597,202.044 229.06,186.457 247.325,186.93   256.052,170.869 264.78,186.93 283.044,186.457 273.508,202.044 283.044,217.632 264.78,217.158 256.052,233.219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256.052,175.105l7.543,13.874l15.787-0.404l-8.244,13.47l8.244,13.47l-15.787-0.404l-7.543,13.874  l-7.543-13.874l-15.787,0.404l8.244-13.47l-8.244-13.47l15.787,0.404L256.052,175.105 M256.052,166.645l-3.55,6.529l-6.362,11.702  l-13.315-0.342l-7.43-0.191l3.88,6.34l6.953,11.36l-6.953,11.36l-3.88,6.34l7.43-0.191l13.315-0.342l6.362,11.702l3.55,6.529  l3.55-6.529l6.362-11.702l13.315,0.342l7.43,0.191l-3.88-6.34l-6.953-11.36l6.953-11.36l3.88-6.34l-7.43,0.191l-13.315,0.342  l-6.362-11.702L256.052,166.645L256.052,166.645z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "197.164,306.435 178.899,306.909 188.436,291.322 178.899,275.734 197.164,276.208   205.891,260.147 214.619,276.208 232.883,275.734 223.347,291.322 232.883,306.909 214.619,306.435 205.891,322.496 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M205.891,264.382l7.543,13.874l15.787-0.404l-8.244,13.47l8.244,13.47l-15.787-0.404l-7.543,13.874  l-7.543-13.874l-15.787,0.404l8.244-13.47l-8.244-13.47l15.787,0.404L205.891,264.382 M205.891,255.923l-3.55,6.529l-6.362,11.702  l-13.315-0.342l-7.43-0.191l3.88,6.34l6.953,11.36l-6.953,11.36l-3.88,6.34l7.43-0.191l13.315-0.342l6.362,11.702l3.55,6.529  l3.55-6.529l6.362-11.702l13.315,0.342l7.43,0.191l-3.88-6.34l-6.953-11.36l6.953-11.36l3.88-6.34l-7.43,0.191l-13.315,0.342  l-6.362-11.702L205.891,255.923L205.891,255.923z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "297.486,306.435 279.221,306.909 288.758,291.322 279.221,275.734 297.486,276.208   306.213,260.147 314.941,276.208 333.205,275.734 323.669,291.322 333.205,306.909 314.941,306.435 306.213,322.496 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M306.213,264.382l7.543,13.874l15.787-0.404l-8.244,13.47l8.244,13.47l-15.787-0.404l-7.543,13.874  l-7.543-13.874l-15.787,0.404l8.244-13.47l-8.244-13.47l15.787,0.404L306.213,264.382 M306.213,255.923l-3.55,6.529l-6.362,11.702  l-13.315-0.342l-7.43-0.191l3.88,6.34l6.953,11.36l-6.953,11.36l-3.88,6.34l7.43-0.191l13.315-0.342l6.362,11.702l3.55,6.529  l3.55-6.529l6.362-11.702l13.315,0.342l7.43,0.191l-3.88-6.34l-6.953-11.36l6.953-11.36l3.88-6.34l-7.43,0.191l-13.315,0.342  l-6.362-11.702L306.213,255.923L306.213,255.923z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.55bd6b4d3f71d1e6c8dddc8c21c54c06.svg";
export { ForwardRef as ReactComponent };